import React, { FunctionComponent, ReactNode } from "react";
import { Modal as SemanticModal, ModalProps as SemanticModalProps, Icon } from "semantic-ui-react";

import "./Modal.css";

interface ModalProps extends SemanticModalProps {
  header?: ReactNode;
  actions?: ReactNode;
  onClose?: () => void;
}

const Modal: FunctionComponent<ModalProps> = ({
  header,
  actions,
  children,
  onClose,
  ...rest
}) => {
  return (
    <SemanticModal
      size="small"
      dimmer="blurring"
      onClose={onClose}
      {...rest}
    >
      {onClose !== undefined && (
        <Icon
          name="x"
          size="large"
          onClick={onClose}
        />
      )}

      {header && (
        <SemanticModal.Header>
          {typeof header === "string" ? (
            <h2>{header}</h2>
          ) : header}
        </SemanticModal.Header>
      )}

      <SemanticModal.Content>
        {children}
      </SemanticModal.Content>

      {actions && (
        <SemanticModal.Actions>
          {actions}
        </SemanticModal.Actions>
      )}
    </SemanticModal>
  );
};

export default Modal;
